<script>
export default {
  name: 'NothingButARouterView'
};
</script>
<template>
  <router-view />
</template>
